import { render, staticRenderFns } from "./two_up_viewer.vue?vue&type=template&id=78673abc"
import script from "./two_up_viewer.vue?vue&type=script&lang=js"
export * from "./two_up_viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports